import { createMfeTestpageApp } from '@common/testpage/MfeTestpageApp.js';
import { projectConfig } from '@root/projectConfig.js';

declare let IS_DEV: boolean;
const app = createMfeTestpageApp({
  apiEndpoint: 'api-consent',
  isDev: IS_DEV,
  port: projectConfig.port,
  tag: 'tef-coms',
});
app.mount('body');
